import FaqGrid from '~/components/Slices/FaqGrid'
import FaqHeader from '~/components/Slices/FaqHeader'

import { ClientPageView } from '~/providers/GTMTrackingProvider/ClientPageView'

import getFaqPageStaticPropsFunction from '~/data/faq-page-data'
import { FaqPageData } from '~/data/faq-page-data/serializer'

function Faq({ header, grid }: FaqPageData) {
  return (
    <>
      {header && <FaqHeader {...header} />}
      {grid && <FaqGrid {...grid} />}
      <ClientPageView template="policy" />
    </>
  )
}

export default Faq

export const getStaticProps = getFaqPageStaticPropsFunction()
